import { createEmbedConsent } from './embedConsent';

const WHEREBY_EMBED_SRC = 'https://cdn.srv.whereby.com/embed/v1.js';

// Whereby sets non-essential cookies. Shared by every Whereby component on the
// page, so consenting in one shows the embed in all of them.
export const {
    consented: wherebyEmbedConsented,
    consent: consentToWherebyEmbed,
    recording: wherebyEmbedConsentRecording,
    failed: wherebyEmbedConsentFailed,
} = createEmbedConsent('whereby');

// Registers the <whereby-embed> custom element. Whereby components call this
// once wherebyEmbedConsented is true, so the script only loads where it is used.
export default function loadWherebyEmbed() {
    if (document.querySelector(`script[src="${WHEREBY_EMBED_SRC}"]`)) {
        return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = WHEREBY_EMBED_SRC;
    document.head.appendChild(script);
}
